import './action-bar.scss'

import { Component, Watch } from 'vue-property-decorator'
import { faPlusSquare } from '@fortawesome/free-regular-svg-icons'
import {
    faClipboardCheck,
    faCogs,
    faExclamation,
    faList,
    faSlash,
    faWifi
} from '@fortawesome/free-solid-svg-icons'


import { OfflineDataFetcher, OfflineDataUpdateCacher } from '@skinsoft/offline'
import { MovementDataStore, TaskDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { SynchroModal } from '@skinsoft/offline-mode'
import { ClickableIconWithLegend, SideMenu } from '@skinsoft/ui'
import { OnlineStatusIndicator } from '@skinsoft/offline-mode/src/components/online-status-indicator'
import { FORCE_CLOSE_MENU_TOPIC } from '../../../busTopics'
import { Routes } from '../../../router'
import { RecordEditMenu } from '../record-edit-screen/record-edit-menu'
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics'

@Component({
    components: {
        clickableIconWithLegend: ClickableIconWithLegend,
        sOnlineStatusIndicator: OnlineStatusIndicator,
        sRecordEditMenu: RecordEditMenu,
        sSideMenu: SideMenu,
        sSynchroModal: SynchroModal
    },
    template: require('./action-bar.html'),
})
export class ActionBar extends ReactiveVue {

    public $refs: {
        synchroModal: SynchroModal
    }

    public $route;

    public movementCount: number = 0;
    public taskCount: number = 0;
    public menuOpened: boolean = false;
    public routeHasMenu: boolean = false;

    public $movementDataStore: MovementDataStore;
    public $taskDataStore: TaskDataStore;

    public toggleSideMenuTopic = TOGGLE_MENU_TOPIC;
    public forceCloseMenuTopic = FORCE_CLOSE_MENU_TOPIC;
    private isSyncError: boolean = false;

    // Icons
    private homeIcon = faList;
    private menuIcon = faCogs;
    private wifiIcon = faWifi;
    private slashIcon = faSlash;
    private errorIcon = faExclamation;
    private archiveIcon = faClipboardCheck;
    private newItemsIcon = faPlusSquare;

    public created() {
        this.subscribeToBus(TOGGLE_MENU_TOPIC, () => {
            this.menuOpened = !this.menuOpened;
        })
        this.fetchSyncError()
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    public toggleMenu() {
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    private async fetchSyncError() {
        this.isSyncError = await OfflineDataUpdateCacher.isPushError() || await OfflineDataFetcher.isSyncError();
    }

    private checkCurrentRoute(routeName) {
        return this.$route.path === routeName;
    }

    private goToHome() {
        this.$router.push({ name: Routes.AUDIT_HOME })
        this.emitOnBus(FORCE_CLOSE_MENU_TOPIC)
    }

    private goToCampaigns() {
        this.$router.push({ name: Routes.CAMPAIGN_SEARCH })
        this.emitOnBus(FORCE_CLOSE_MENU_TOPIC)
    }

    private goToNewItems() {
        this.$router.push({ name: Routes.NEW_ITEMS})
        this.emitOnBus(FORCE_CLOSE_MENU_TOPIC)
    }

    private toogleSynchroModal() {
        this.$refs.synchroModal.open()
    }

    @Watch('$route', { immediate: true, deep: true })
    private onRouteChange($route) {
        this.routeHasMenu = !!$route.matched.find(match => !!match.components.actionMenu);
        if (!this.routeHasMenu) {
            this.emitOnBus(FORCE_CLOSE_MENU_TOPIC);
        }
        this.menuOpened = false;
    }
}
